import PropTypes from 'prop-types';

const PulsingDot = ({ colors, showPulse }) => (
	<div className="relative flex-shrink-0">
		{showPulse && (
			<div
				className={`absolute -top-0.5 -left-0.5 w-3 h-3 rounded-full animate-ping opacity-50 ${colors.ping}`}
			/>
		)}
		<div className={`w-2 h-2 rounded-full relative z-10 ${colors.dot}`} />
	</div>
);

PulsingDot.propTypes = {
	colors: PropTypes.shape({
		ping: PropTypes.string.isRequired,
		dot: PropTypes.string.isRequired,
	}).isRequired,
	showPulse: PropTypes.bool,
};

export default PulsingDot;
